/**
 * Production-ready logger for Check-in/Check-out.
 * - In development: logs info and errors.
 * - In production: logs only errors (and optionally warnings).
 */
const isDev = typeof import.meta !== "undefined" && import.meta.env?.DEV === true;
const PREFIX = "[CheckInOut]";

export const checkInOutLogger = {
    info(message: string, meta?: Record<string, unknown>): void {
        if (isDev) {
            if (meta && Object.keys(meta).length > 0) {
                console.info(`${PREFIX} ${message}`, meta);
            } else {
                console.info(`${PREFIX} ${message}`);
            }
        }
    },
    error(message: string, error?: unknown): void {
        if (error !== undefined) {
            console.error(`${PREFIX} ${message}`, error);
        } else {
            console.error(`${PREFIX} ${message}`);
        }
    },
    warn(message: string, meta?: Record<string, unknown>): void {
        if (isDev) {
            if (meta) console.warn(`${PREFIX} ${message}`, meta);
            else console.warn(`${PREFIX} ${message}`);
        }
    },
};
